import SVG from 'react-inlinesvg'
import React from 'react'
import './SenderId.scss'

type Props = {
  imagePath: string
  title: string
  description: string
  actionButtonText?: string
  showActionButton: boolean
  onClickActionButton?: () => void
  onClickLearnMore: () => void
}

const SenderIdInfoCard: React.FC<Props> = ({
  imagePath,
  title,
  description,
  showActionButton,
  actionButtonText,
  onClickActionButton,
  onClickLearnMore,
}) => {
  return (
    <div className='card border-0 card-sender-id' style={{borderRadius: '8px', overflow: 'hidden'}}>
      <div
        className='d-flex justify-content-center align-items-end position-relative'
        style={{height: '124px', backgroundColor: '#F3F0FF'}}
      >
        <SVG src={imagePath} className='' style={{width: '222px'}} />
      </div>

      <div className='card-body '>
        <div>
          <h4 className='fw-bolder'>{title}</h4>
          <p>
            {description}{' '}
            <a href='#' onClick={onClickLearnMore}>
              Learn more
            </a>
          </p>
        </div>
      </div>
      {showActionButton && (
        <button onClick={onClickActionButton} className='btn btn-light-primary-with-hover'>
          {actionButtonText}
        </button>
      )}
    </div>
  )
}

export default SenderIdInfoCard
